'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import WorldAldarNavigation from '@components/WorldAldarNavigation';

import cn from './style.module.scss';

export default function EastvaleIntroduction(
  props: MarketingPageComponentProps
) {
  const introductionSection = props?.locale?.section?.find(
    (section: any) => section.type === 'introduction' && section.enabled
  );
  if (!introductionSection) return null;
  return (
    <Stack component="section" className={cn.eastvaleIntroductionWrapper}>
      <Box className={cn.eastvaleIntroductionInner}>
        <CommonContainer
          paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
          maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.eastvaleIntroductionBlock}>
            <Box className={cn.eastvaleIntroductioWorld}>
              <WorldAldarNavigation
                data={introductionSection?.eastvaleAboutWorldOfAldar}
                classNames={{
                  wrapper: cn.eastvaleIntroductioWrapper,
                  data: cn.eastvaleIntroductioData,
                  button: cn.eastvaleIntroductioButton,
                }}
              />
            </Box>
            <Box className={cn.eastvaleIntroductionContent}>
              <Box className={cn.eastvaleIntroductionContent__heading}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    introductionSection?.eastvaleIntroductionHeading
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.eastvaleIntroductionContent__data}>
                {introductionSection?.eastvaleIntroductionContent.map(
                  (text: string, index: number) => (
                    <ParallaxText
                      key={index}
                      variant="p"
                      animationType="zoomIn"
                      animationDuration={500}
                    >
                      {ReactHtmlParser(text)}
                    </ParallaxText>
                  )
                )}
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
